import { render, staticRenderFns } from "./ChatRichMediaAlbum.vue?vue&type=template&id=0722474c&scoped=true"
import script from "./ChatRichMediaAlbum.vue?vue&type=script&lang=js"
export * from "./ChatRichMediaAlbum.vue?vue&type=script&lang=js"
import style0 from "./ChatRichMediaAlbum.vue?vue&type=style&index=0&id=0722474c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722474c",
  null
  
)

export default component.exports